export const typeOptions = [{label: "Privati", value: "private"}, {label: "Business", value: "business"}]